import { render } from "./Video.vue?vue&type=template&id=1550e7cc"
const script = {}

import "./Video.vue?vue&type=style&index=0&id=1550e7cc&lang=css"
script.render = render

export default script